module.exports = __webpack_public_path__ + "assets/plus.947861fb.svg";